import { Warrants } from '@factorin/domain';

import { withUrl, list } from '../rest';


const warrantsPart = withUrl('warrant-templates');

export const warrants = {
    list: list<Warrants.Warrant>(warrantsPart()).list,
};
